<template>
    <div>
        <!-- 过滤条件 -->
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 4px"
        >
            <!-- 选择房源 -->
            <form-lookup
                style="
                    min-width: 262px;
                    margin-right: 15px;
                    max-height: 90px;
                    overflow: auto;
                "
                v-model="selectRoom.roomId"
                :options.sync="selectRoom.roomList"
                placeholder="房源名称"
                title="选择房间"
                textSymbol="title"
                valueSymbol="id"
                :modalHeight="600"
                :modalWidth="900"
                @change="onSelectRoom"
                @clear="onClearRoom"
                @deselect="onDeselectRoom"
            >
                <select-room multiple />
            </form-lookup>
            <!-- 选择排序 -->
            <Select
                style="width: 200px; margin-right: 15px"
                v-model="filter.orderBys"
                placeholder="排序类型"
                @on-change="search"
            >
                <Option
                    v-for="item in orderBysList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <!-- 高级搜索 -->
            <c-adv-search
                ref="adv"
                v-model="advFilter"
                :name="accessName"
                @confirm="onAdvConfirm"
            ></c-adv-search>
        </div>
        <!-- 已选中的搜索条件 -->
        <select-tags
            v-model="advOptions"
            style="margin-bottom: 4px"
            @close="onAdvItemClose"
        ></select-tags>
        <!-- 表格工具栏 -->
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.cusUser"
                    placeholder="请输入客户姓名,手机号或单位名称"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                :class="preCls + 'button-margin'"
                v-if="$can('add')"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
            >
                录入合同
            </Button>
            <Button
                v-if="$can('exportExcel')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                :loading="loadingExport"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:contractStatusText="{ row }">
                <tag-status
                    :text="row.contractStatusText"
                    :color="row.contractStatusColor"
                    :background="row.contractStatusBgc"
                    circle
                />
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickInfo(row)"
                    v-if="
                        $can('view', 'api/contract/view/detail') ||
                        $can('view', 'api/contract/view/bill')
                    "
                >
                    详情
                </Button>
                <!-- row.contractStatus === '27' 租客签约中的状态只允许使用详情按钮， -->
                <span v-if="row.showOtherHandler">
                    <Button
                        type="default"
                        size="small"
                        style="margin-right: 5px"
                        @click="rowClickRenewal(row)"
                        v-if="$can('renewal')"
                        :disabled="row.contractStatus === '27' || row.contractStatus === '28' || row.contractStatus === '29'"
                    >
                        续租
                    </Button>
                    <Button
                        type="default"
                        size="small"
                        style="margin-right: 5px"
                        @click="rowClickSurrender(row)"
                        v-if="$can('surrender')"
                        :disabled="row.contractStatus === '27' || row.contractStatus === '28' || row.contractStatus === '29'"
                    >
                        退租
                    </Button>
                    <!-- 只允许换房一次，当换房后，就不能再次换房 -->
                    <Button
                        type="default"
                        size="small"
                        style="margin-right: 5px"
                        @click="rowClickExchange(row)"
                        v-if="$can('exchange')"
                        :disabled="row.contractStatus === '4' || row.contractStatus === '27' || row.contractStatus === '28' || row.contractStatus === '29'"
                    >
                        换房
                    </Button>
                </span>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { pipeCell } from '_c/grid/renderCell'
import { currency, ymd } from '_u/helper'
import Dict from '_u/dict'

import mContractList from '_v/common/m-contract-list'
import SelectRoom from '_vc/select-room'
import TagStatus from '_vc/tag-status'
import FilterDateRange from '_v/components/filter/filter-date-range'

import { contractList } from '@/api/contract'
import { queryUserName } from '@/api/sys-user'

export default {
    name: 'c-rent-list',
    mixins: [mContractList],
    components: { SelectRoom, TagStatus, FilterDateRange },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            loadingExport: false,
            curId: '',
            page: {
                total: 0,
                list: [],
            },
            dict: {
                contractTpl: Dict.NULL,
                contractDateType: Dict.NULL,
                contractStatus: Dict.NULL,
            },
            contractStatusList: [],
        }
    },

    computed: {
        ...mapCache({
            filter: 'rentFilter',
            advFilter: 'rentAdvFilter',
            advOptions: 'rentAdvOptions',
            selectRoom: 'rentSelectRoom',
        }),

        columns() {
            const arr = [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 70,
                },
                {
                    key: 'houseName',
                    title: '房源名称',
                    align: 'left',
                    minWidth: 200,
                    ellipsis: true,
                    tooltip: true,
                },
                {
                    key: 'cusName',
                    title: '客户姓名',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true,
                },
                {
                    key: 'cusMobile',
                    title: '客户手机号',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'comName',
                    title: '单位名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'contractStatusText',
                    title: '租约状态',
                    align: 'center',
                    minWidth: 160,
                    slot: 'contractStatusText',
                },
                {
                    key: 'startDate',
                    title: '合同开始日期',
                    align: 'center',
                    width: 130,
                },
                {
                    key: 'endDate',
                    title: '合同结束日期',
                    align: 'center',
                    width: 130,
                },
                {
                    key: 'rent',
                    title: '租金(元/月)',
                    align: 'right',
                    minWidth: 120,
                },
                {
                    key: 'contractType',
                    title: '合同类型',
                    align: 'center',
                    minWidth: 100,
                },
                {
                    key: 'signUser',
                    title: '签约人',
                    align: 'center',
                    width: 100,
                },
                {
                    key: 'updateTime',
                    title: '合同操作时间',
                    align: 'center',
                    width: 150,
                    render: pipeCell('ymdL'),
                },
                {
                    key: 'updateUserName',
                    title: '操作人',
                    align: 'left',
                    width: 120,
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 230,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
            const item = arr.find((v) => v.key === this.filter.order)
            item.sortType = this.filter.orderBy
            return arr
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                Dict.get([
                    // 'contract_type',
                    'contract_tpl',
                    'contract_status',
                    'contract_date_type',
                ]),
                queryUserName(),
                contractList(
                    Object.assign(
                        {},
                        this.filter,
                        this.normalizeAdvFilter(this.advFilter)
                    )
                ),
            ])
                .then((args) => {
                    var [dictGroup, users, view] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (users) {
                        this.userNameMap = this.normalizeUserName(users.data)
                    }

                    this.page.list = this.normalizePageData(view.data.page.list)
                    this.page.total = parseInt(view.data.page.totalCount)

                    const contractStatusList = []
                    this.dict.contractStatus.toList().forEach((v) => {
                        v.remark = JSON.parse(v.remark)
                        if (v.remark.status === '1') {
                            contractStatusList.push(v)
                        }
                    })
                    this.contractStatusList = contractStatusList
                })
                .finally(() => {
                    this.loading = false
                })
        },
        search() {
            this.filter.pageNo = 1
            if (!this.filter.contractStatus) {
                this.filter.contractStatus = '1,2,3,4,5,6,11,27,28,29'
            }
            this.fetch()
        },
        // 数据格式标准化
        normalizePageData(list) {
            const contractStatusDict = this.dict.contractStatus
            list.forEach((v) => {
                const status = contractStatusDict.get(v.contractStatus)

                v.date = `${v.startDate} 至 ${v.endDate}`
                v.rent = currency(v.rent / 100)
                v.showOtherHandler = v.contractStatus !== '2'
                v.contractType = this.dict.contractTpl.val(v.contractType)

                v.contractStatusText = status.text
                v.contractStatusColor = JSON.parse(status.remark).color
                v.contractStatusBgc = JSON.parse(status.remark).background
                // 即将到期 合同逾期
                const nowDate = new Date(ymd(new Date()))
                const endDate = new Date(v.endDate)
                // 合同逾期
                if (nowDate > endDate) {
                    v.overdue = '1'
                }
                v.houseName = v.houseName.split('(')[0]
                v.updateUserName = this.userNameMap[v.updateUserId] || ''
            })
            return list
        },
        // 合同录入
        onClickAdd(e) {
            this.$router.push({
                name: 'contractCreate',
                query: { from: 'contractIndex' },
            })
        },
        // 导出Excel
        onClickExport() {
            this.loadingExport = true

            contractList(
                Object.assign(
                    {},
                    this.filter,
                    this.normalizeAdvFilter(this.advFilter),
                    {
                        pageNo: 1,
                        pageSize: -1,
                    }
                )
            )
                .then((res) => {
                    var $mt = this.$refs.mt
                    $mt.exportToExcel({
                        rows: this.normalizePageData(res.data.page.list),
                    })
                })
                .finally(() => {
                    this.loadingExport = false
                })
        },
        // 合同详情
        rowClickInfo(row) {
            this.$router.push({
                name: 'contractViewIndex',
                query: { contractId: row.id, type: '5' },
            })
        },
        // 合同续租
        rowClickRenewal(row) {
            this.$router.push({
                name: 'contractRenewal',
                query: { contractId: row.id, type: '2' },
            })
        },
        // 合同退租
        rowClickSurrender(row) {
            this.$router.push({
                name: 'contractSurrender',
                query: { contractId: row.id, type: '3' },
            })
        },
        // 合同换房
        rowClickExchange(row) {
            this.$router.push({
                name: 'contractExchange',
                query: { contractId: row.id, type: '4' },
            })
        },
    },
}
</script>
<style lang="less" scoped></style>
